module.exports = __webpack_public_path__ + "img/1481509646.308dbde1.jpg";